import React, {Fragment, useState} from "react";
import CommonHeader from "../../components/Headers/CommonHeader";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/protectedContent";
import CustomFieldsModal from "./customFieldsModal";
import CustomFieldsTable from "./customFieldsTable";

const CustomFields = () => {
  const [modalStatus, setModalStatus] = useState(false);

  return (
    <SafeView>
      <ProtectedContent perms={["view_customfield"]} showFallback>
        <Fragment>
          {modalStatus && (
            <CustomFieldsModal
              open={modalStatus}
              onCancel={() => setModalStatus(false)}
            />
          )}
          <ProtectedContent perms={["add_customfield"]}>
            <CommonHeader
              content={"Add Custom Field"}
              handleAddClick={() => setModalStatus(true)}
              testID={"add_custom_field"}
            />
          </ProtectedContent>
          <CustomFieldsTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

export default CustomFields;
